import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Flex, Form, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { usePackagingModelValue } from 'context';
import { createPackagingModel, updatePackagingModel } from 'services';
import { PATHNAME } from 'utils';

import { PackagingModelFormAction } from './action';
import { PackagingModelFormContent } from './content';

const {
  LOCAL: {
    PACKAGING_MODELS: { BASE_URL: PACKAGING_MODELS_BASE_URL },
  },
} = PATHNAME;

type FieldType = Pick<
  ReturnType<typeof usePackagingModelValue>,
  'name' | 'label' | 'helpText'
>;

const PackagingModelForm = () => {
  const [form] = Form.useForm<FieldType>();
  const {
    id = '',
    categories = [],
    defaultName,
    mode,
  } = usePackagingModelValue();
  const navigate = useNavigate();

  const onFinish = useLockFn(
    async ({ name = '', label = '', helpText = '' }: FieldType) => {
      const isUpdatedMode = mode === 'Update';

      const params: Parameters<typeof updatePackagingModel>[0] = {
        id,
      };
      const body: Parameters<typeof updatePackagingModel>[1] = {
        name,
        label,
        helpText,
        categoriesIds: categories.map(({ id }) => id),
      };

      (isUpdatedMode
        ? updatePackagingModel(params, body)
        : createPackagingModel(body)
      )
        .then(() => {
          notification.success({
            message: `بسته‌بندی ${isUpdatedMode ? defaultName : name} با موفقیت ${isUpdatedMode ? 'ویرایش' : 'ساخته'} شد.`,
          });
          navigate(PACKAGING_MODELS_BASE_URL);
        })
        .catch(message => {
          notification.error({ message });
        });
    },
  );

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Flex
        className='*:rounded *:bg-white max-xl:flex-col max-xl:last:*:sticky max-xl:last:*:inset-x-0 max-xl:last:*:bottom-0 max-xl:last:*:z-10 max-xl:last:*:shadow-inner xl:items-start xl:first:*:basis-[70%] xl:last:*:basis-[30%]'
        gap='large'
      >
        <PackagingModelFormContent />
        <PackagingModelFormAction />
      </Flex>
    </PrimitiveForm>
  );
};

export { PackagingModelForm };
